function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default class MerchantSubunitBasic extends ApplicationSerializer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "primaryKey", 'token');
    _defineProperty(this, "collectionKey", 'entities');
    _defineProperty(this, "rootKey", 'entity');
  }
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // if the response is nested inside the collection key or root-key, use that
    const newPayload = payload[this.collectionKey] || payload[this.rootKey] || payload;
    return super.normalizeResponse(store, primaryModelClass, newPayload, id, requestType);
  }
  pushPayload(store, payload) {
    const modelName = this.toString().split(':')[1];
    const modelClass = store.modelFor(modelName);
    const normalized = this.normalizeSingleResponse(store, modelClass, payload);

    // pushPayload does not return the record.
    // If the record is needed after this function, use peekRecord.
    store.push(normalized);
  }
}